import React, { ButtonHTMLAttributes, useMemo } from 'react';
import './Button.css';

export type ButtonProps = {
  isDisabled?: boolean;
  isPrimary?: boolean;
  isWhite?: boolean;
  label?: string;
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
  onClick?: () => void;
};

export const Button: React.FC<ButtonProps> = ({
  isDisabled = false,
  isPrimary = false,
  isWhite = false,
  label,
  onClick,
  type = 'button',
}) => {
  const buttonClass = isPrimary ? 'button--primary' : '';
  const whiteButtonClass = isWhite ? 'button--white' : '';
  const disabledClass = isDisabled ? 'button--disabled' : '';
  const labelUppercase = useMemo(() => label?.toUpperCase(), [label]);

  return (
    <button
      type={type}
      disabled={isDisabled}
      onClick={!isDisabled ? onClick : undefined}
      className={`button--default ${disabledClass} ${buttonClass} ${whiteButtonClass}`}
    >
      {labelUppercase}
    </button>
  );
};
